var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('v-tabs',{staticClass:"mb-4"},_vm._l((_vm.reorganizedTabs),function(ref){
var name = ref.name;
var path = ref.path;
return _c('v-tab',{key:path,attrs:{"to":path}},[_vm._v(_vm._s(name))])}),1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }